import { render, staticRenderFns } from "./TemplatesForm.vue?vue&type=template&id=2b70b8ce&"
import script from "./TemplatesForm.vue?vue&type=script&lang=js&"
export * from "./TemplatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports